import { tableFeatures } from "@tanstack/react-table";

/**
 * Table V9 requires every feature to be registered explicitly so the unused
 * ones can be tree-shaken. Our tables only ever render the core row model —
 * no sorting, filtering or pagination happens client-side, the API returns
 * one page at a time — so the feature set is empty.
 *
 * Column definitions have to be typed against the same feature set as the
 * table that renders them, hence the exported type.
 */
export const dataTableFeatures = tableFeatures({});

export type DataTableFeatures = typeof dataTableFeatures;
